<div class="container  pl-0 pr-0">

  <ng-container *ngIf="listaPreguntas === null">
    Cargando preguntas...
  </ng-container>

  <div style="padding: 10px 0px"></div>
    <form>
      <mat-tab-group #tabGroup [selectedIndex]="selectedIndex" (selectedIndexChange)="fnIsDone(tabGroup.selectedIndex)">
        <mat-tab *ngFor="let pregunta of listaPreguntas; let i = index">
          <ng-template mat-tab-label>Pregunta {{pregunta.orden}}</ng-template>
          <div class="card-body">
            <div class="title-pregunta">{{pregunta.descripcion}}
            </div>
              <div style="padding: 5px 0px"></div>
              <div *ngIf="pregunta.tipoPregunta == 2" class="alert alert-info p-2" role="alert">
                <mat-icon aria-label="icon-button with a heart icon">info</mat-icon>
                <span>{{pregunta.mensajePregunta}}</span>
              </div>

              <div *ngIf="pregunta.tipoPregunta == 1" >
                <mat-radio-group class="opcion-radio-group"  name="codigo{{i}}" (change)="onChangeRadio($event, i)" >
                    <mat-radio-button   class="opcion-radio-button" *ngFor="let opcion of pregunta.opciones"  [value]="opcion.descripcion" [checked]="opcion.checked">  
                    {{opcion.descripcion}}
                    </mat-radio-button>
                </mat-radio-group>
              </div>

              <div *ngIf="pregunta.tipoPregunta == 2" >
                <div *ngFor="let opcion of pregunta.opciones" >
                    <mat-checkbox name="check{{i}}" [checked]="opcion.checked" 
                    (change)="onChangeCheckBox($event, i)" [value]="opcion.descripcion">{{opcion.descripcion}}</mat-checkbox>
                  </div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
        <div style="text-align: center">
            <button mat-stroked-button color="secondary" type="button"  [disabled]="isBtnDisabled" (click)="tabGroup.selectedIndex = tabGroup.selectedIndex - 1"> <mat-icon>keyboard_arrow_left</mat-icon> Atras</button>
            <ng-container>
            <button mat-stroked-button color="secondary" type="button" class="mx-2" (click)="clearSelections(tabGroup.selectedIndex, tabGroup)">Limpiar </button>
          </ng-container>
            <ng-container *ngIf="showFinalizarB | async">
              <button mat-stroked-button color="secondary" type="button" [disabled]="isBtnDisabled" (click)="tabGroup.selectedIndex = tabGroup.selectedIndex + 1" (click)="enviarVotacion(tabGroup.selectedIndex)"> Registrar Voto <mat-icon>keyboard_arrow_right</mat-icon> </button>
            </ng-container>
            <ng-container *ngIf="showFinalizar | async">
              <button mat-raised-button color="primary" type="button" [disabled]="isBtnDisabled" class="mx-2 mat-raised-button mat-button-base mat-primary" (click)="enviarVotacionFinal(tabGroup.selectedIndex)"> Finalizar Voto</button>
            </ng-container>
        </div>
    </form>
</div>
